// extracted by mini-css-extract-plugin
export default {"tooltip":"dn-z","sharingV2":"en-z","sharingIconsV2":"fn-z","links":"gn-z","link":"hn-z","facebookV2":"in-z","twitterV2":"jn-z","pinterestV2":"kn-z"};